// src/registerServiceWorker.js
if (process.env.NODE_ENV === 'production') {
    const { register } = require('register-service-worker')
  
    register(`${process.env.BASE_URL}service-worker.js`, {
      ready() {
        console.log('アプリはサービスワーカーによってキャッシュから提供されています。')
      },
      registered() {
        console.log('サービスワーカーが登録されました。')
      },
      cached() {
        console.log('コンテンツがオフライン用にキャッシュされました。')
      },
      updatefound() {
        console.log('新しいコンテンツがダウンロード中です。')
      },
      updated() {
        console.log('新しいコンテンツが利用可能です。リフレッシュしてください。')
      },
      offline() {
        console.log('インターネット接続が見つかりません。アプリはオフラインモードで動作しています。')
      },
      error(error) {
        console.error('サービスワーカーの登録中にエラーが発生しました:', error)
      }
    })
  }
  